import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { TranslateModule } from '@ngx-translate/core';
import { SiteConfigService } from '@shared/shared/services/site-config.service';

@Component({
  selector: 'ten-map-toggle-button',
  templateUrl: './map-toggle-button.component.html',
  styleUrls: ['./map-toggle-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatLegacyButtonModule, TranslateModule],
})
export class MapToggleButtonComponent implements OnInit, OnDestroy {
  @Input() public buttonId: number;
  @Input() public layout: string;
  @Input() public countryCode = '';
  @Input() public disabled = false;

  public imgSrc = 'assets/images/map/map.svg';
  public useBlackMapIcon = false;

  @Output() public isInited = new EventEmitter();
  @Output() public isDestroyed = new EventEmitter();

  constructor(private siteConf: SiteConfigService) {}

  public ngOnInit() {
    this.useBlackMapIcon = this.siteConf.getComponentData('dining-search-results').default?.useBlackMapIcon;
    this.imgSrc = this.setImgSrc();
    this.isInited.emit();
  }

  private setImgSrc(): string {
    const countryCodes = ['DO'];
    const whiteIcon = 'assets/images/map/map.svg';
    const blackIcon = 'assets/images/map/map-black.svg';
    return countryCodes.includes(this.countryCode) || this.useBlackMapIcon ? blackIcon : whiteIcon;
  }

  public ngOnDestroy() {
    this.isDestroyed.emit();
  }
}
